import _classPrivateFieldInitSpec from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import "core-js/modules/es.error.cause.js";

var _neverError = /*#__PURE__*/new WeakMap();

// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * @name DoNotConstruct
 * @description
 * An unknown type that fails on construction with the type info
 */
export class DoNotConstruct {
  constructor(registry) {
    let typeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DoNotConstruct';

    _classPrivateFieldInitSpec(this, _neverError, {
      writable: true,
      value: void 0
    });

    this.registry = registry;

    _classPrivateFieldSet(this, _neverError, new Error(`DoNotConstruct: Cannot construct unknown type ${typeName}`));

    throw _classPrivateFieldGet(this, _neverError);
  }

  static with(typeName) {
    return class extends DoNotConstruct {
      constructor(registry) {
        super(registry, typeName);
      }

    };
  }
  /**
   * @description The length of the value when encoded as a Uint8Array
   */


  get encodedLength() {
    throw _classPrivateFieldGet(this, _neverError);
  }
  /**
   * @description returns a hash of the contents
   */


  get hash() {
    throw _classPrivateFieldGet(this, _neverError);
  }
  /**
   * @description Checks if the value is an empty value (always true)
   */


  get isEmpty() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  eq() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  inspect() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  toHex() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  toHuman() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  toJSON() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  toPrimitive() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  toRawType() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  toString() {
    throw _classPrivateFieldGet(this, _neverError);
  }

  toU8a() {
    throw _classPrivateFieldGet(this, _neverError);
  }

}